import { PolicyRegistry } from './cookie-popup.models';

export const REGISTRY: PolicyRegistry = {
  policyVersion: '2025-09-01',
  lastUpdatedISO: '2025-09-04T00:00:00.000Z',
  vendors: [
    {
      id: 'ga4',
      name: 'Google Analytics 4',
      policyUrl: 'https://policies.google.com/privacy',
      categories: 'label_site_analytics',
    },
    {
      id: 'google-ads',
      name: 'Google Ads',
      policyUrl: 'https://policies.google.com/technologies/ads',
      categories: 'label_google_ads',
    },
    {
      id: 'sentry',
      name: 'Sentry',
      policyUrl: 'https://sentry.io/privacy/',
      categories: 'label_technical',
    },
  ],
  items: [
    // Essential app settings in localStorage
    {
      key: 'user_prefs',
      storage: 'localStorage',
      category: 'label_essential',
      vendorId: 'label_website',
      purpose: 'sentence_layout_preferences',
      retention: 'label_until_cleared',
      pattern: '^shared_data'
    },

    // Cross-domain checkout handoff cookie
    {
      key: 'migrate-cart-*',
      storage: 'cookie',
      category: 'label_essential',
      vendorId: 'label_website',
      purpose: 'sentence_session_handoff',
      retention: 'label_session' // or '1 day' if you set a max-age
    },
    {
      key: '_ga',
      storage: 'cookie',
      category: 'label_site_analytics',
      vendorId: 'ga4',
      purpose: 'label_distinguish_users',
      retention: 'label_2_years',
      pattern: '^_ga$',
    },
    {
      key: '_ga_.*',
      storage: 'cookie',
      category: 'label_site_analytics',
      vendorId: 'ga4',
      purpose: 'label_session_management',
      retention: 'label_2_years',
      pattern: '^_ga_[A-Z0-9]+',
    },
    {
      key: '_gid',
      storage: 'cookie',
      category: 'label_site_analytics',
      vendorId: 'ga4',
      purpose: 'label_session_identifier',
      retention: 'label_24_hours',
    },
    {
      key: 'AMP_.*',
      storage: 'cookie',
      category: 'label_site_analytics',
      vendorId: 'ga4',
      purpose: 'label_amp_client_ids',
      retention: 'label_13_months',
      pattern: '^AMP.*',
    },
    {
      key: 'FPAU',
      storage: 'cookie',
      category: 'label_google_ads',
      vendorId: 'google-ads',
      purpose: 'label_ad_user_data',
      retention: 'label_13_months',
      pattern: '^FPA',
    },
    {
      key: 'sentry-sc',
      storage: 'cookie',
      category: 'label_technical',
      vendorId: 'sentry',
      purpose: 'label_error_tracking_cookie',
      retention: 'label_session',
    },
    {
      key: 'sentry-sudo',
      storage: 'cookie',
      category: 'label_technical',
      vendorId: 'sentry',
      purpose: 'label_session_management',
      retention: 'label_until_cleared',
    },
    {
      key: 'session',
      storage: 'cookie',
      category: 'label_technical',
      vendorId: 'sentry',
      purpose: 'label_session_identifier',
      retention: 'label_session',
    },
  ]

};
